import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';
import RegisterPopup from './RegisterPopup';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();

  const services = [
    { name: 'Trademark Registration', path: '/trademark-registration' },
    { name: 'Copyright Registration', path: '/copyright-registration' },
    { name: 'Trademark Comprehensive Search', path: '/trademark-comprehensive-search' },
    { name: 'Company Formation', path: '/company-formation' },
    { name: 'Amazon Brand Registry', path: '/amazon-brand-registry' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <header className="bg-white shadow-md sticky top-0 z-40">
        <div className="mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-2">
              <img src="/assets/img/brand/logo-dark.png" alt="IP Protection Center" className="h-12" />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              <Link
                to="/"
                className={`text-gray-700 hover:text-brand-500 font-medium transition-colors ${
                  isActive('/') ? 'text-brand-500' : ''
                }`}
              >
                Home
              </Link>
              <Link
                to="/about"
                className={`text-gray-700 hover:text-brand-500 font-medium transition-colors ${
                  isActive('/about') ? 'text-brand-500' : ''
                }`}
              >
                About Us
              </Link>

              {/* Services Mega Menu */}
              <div
                className="relative"
                onMouseEnter={() => setServicesOpen(true)}
                onMouseLeave={() => setServicesOpen(false)}
              >
                <button 
                  className="flex items-center text-gray-700 hover:text-brand-500 font-medium transition-colors py-2"
                  onClick={(e) => {
                    e.preventDefault();
                    setServicesOpen(!servicesOpen);
                  }}
                >
                  Services
                  <ChevronDown className={`ml-1 h-4 w-4 transition-transform ${servicesOpen ? 'rotate-180' : ''}`} />
                </button>

                {/* Dropdown Menu */}
                {servicesOpen && (
                  <div className="absolute left-0 top-full pt-2 w-64 z-[100]">
                    <div className="bg-white rounded-md shadow-lg border border-gray-200 py-1">
                      {services.map((service) => (
                        <Link
                          key={service.path}
                          to={service.path}
                          className="block px-4 py-2 text-sm text-gray-700 hover:bg-brand-50 hover:text-brand-500 transition-colors"
                          onClick={() => {
                            setServicesOpen(false);
                            setMobileMenuOpen(false);
                          }}
                        >
                          {service.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <Link
                to="/contact"
                className={`text-gray-700 hover:text-brand-500 font-medium transition-colors ${
                  isActive('/contact') ? 'text-brand-500' : ''
                }`}
              >
                Contact Us
              </Link>
            </nav>

            {/* Right Side Buttons */}
            <div className="hidden lg:flex items-center space-x-4">
              <Button
                onClick={() => setShowPopup(true)}
                className="bg-brand-500 hover:bg-brand-600 text-white px-6"
              >
                Register My Trademark
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden text-gray-700"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="lg:hidden py-4 border-t">
              <div className="flex flex-col space-y-4">
                <Link to="/" className="text-gray-700 hover:text-brand-500 font-medium">
                  Home
                </Link>
                <Link to="/about" className="text-gray-700 hover:text-brand-500 font-medium">
                  About Us
                </Link>
                <div className="space-y-2">
                  <div className="font-medium text-gray-900">Services</div>
                  <div className="pl-4 space-y-2">
                    {services.map((service) => (
                      <Link
                        key={service.path}
                        to={service.path}
                        className="block text-gray-600 hover:text-brand-500"
                      >
                        {service.name}
                      </Link>
                    ))}
                  </div>
                </div>
                <Link to="/contact" className="text-gray-700 hover:text-brand-500 font-medium">
                  Contact Us
                </Link>
                <Button
                  onClick={() => setShowPopup(true)}
                  className="bg-brand-500 hover:bg-brand-600 text-white w-full"
                >
                  Register My Trademark
                </Button>
              </div>
            </div>
          )}
        </div>
      </header>

      {showPopup && <RegisterPopup onClose={() => setShowPopup(false)} />}
    </>
  );
};

export default Header;